import PropTypes from 'prop-types';

import { Colors } from '@spotahome/ui-library';

const theme = {
  base: Colors.primary,
  light: 'white',
  interaction: Colors.interaction,
  interactionDark: Colors['interaction-dark']
};

const Photos = props => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 14H14V0H0V14ZM4.61823 6.87287L6.22292 8.95091L8.71693 5.40907L12.84 11.2644H1.75L4.61823 6.87287Z"
      fill={theme[props.theme]}
    />
  </svg>
);

Photos.propTypes = {
  theme: PropTypes.oneOf(['base', 'light', 'interaction', 'interactionDark'])
};

Photos.defaultProps = {
  theme: 'base'
};
export default Photos;
